import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M39 15.01c-6.585.144-11.896 1.714-15.957 4.693A5 5 0 0 0 21 23.735V36a7 7 0 0 1-7 7h-2a5 5 0 0 1-5-5v-.188a5.5 5.5 0 0 1 4.596-5.425L19 31.153V15.062a7 7 0 0 1 3.434-6.024C26.992 6.34 32.85 5 40 5a1 1 0 0 1 1 1v24a7 7 0 0 1-7 7h-2a5 5 0 0 1-5-5v-.188a5.5 5.5 0 0 1 4.596-5.425L39 25.153V15.01Z",
      clipRule: "evenodd"
    }
  )
);
var SvgMusicFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MusicFilled_default = SvgMusicFilled;

export { MusicFilled_default as default };
